import { render, staticRenderFns } from "./u-lazy-load.vue?vue&type=template&id=f135ec92&scoped=true&"
import script from "./u-lazy-load.vue?vue&type=script&lang=js&"
export * from "./u-lazy-load.vue?vue&type=script&lang=js&"
import style0 from "./u-lazy-load.vue?vue&type=style&index=0&id=f135ec92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f135ec92",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-lazy-load/u-lazy-load.vue"
export default component.exports